export enum StatisticPeriodEnum {
    Day,
    Month,
    Year,
    Custom,
}
